import React, {useState} from 'react';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import {can} from '../../../_common/components/Permissions';
import {permissionTypes as T, subjects as S} from '../../../_common/constants/permissionSubjects';
import FormChangeFileType from '../FormChangeFileType';
import ButtonAction from '../../../_common/components/ButtonAction';
import ModalContainer from '../../../_common/components/ModalContainer';

const ButtonUpdateFileType = ({fileID, fileTypeID}) => {
  const [show, setShow] = useState(false);
  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <>
      <ButtonAction
        variant={'icon'}
        iconButtonType={'primary'}
        title={TTS.EDIT}
        disabled={!can(T.FULL, S.ORDERS_PAGE)}
        onClick={handleOpen}
        label={<img src={'../../../media/common/Edit_primary.svg'} alt="edit"/>}
      />
      <ModalContainer show={show} onClose={handleClose} size={'md'}>
        <FormChangeFileType fileID={fileID} fileTypeID={fileTypeID} onClose={handleClose}/>
      </ModalContainer>
    </>
  );
};

export default ButtonUpdateFileType;